import React, { useContext } from "react";
import { withRouter } from "react-router-dom";

import { Grid, Typography } from "@material-ui/core";
import { SectionTitle, ListItem, List, UserSubscriptions } from "../../_common";

import { Context as AuthContext } from "../../../context/AuthContext";
import useStyles from "./styles";

const ProfileInfo = ({ data, history }) => {
  const { pbRoot, pbBio, pbSignoutContainer } = useStyles();

  const { signout } = useContext(AuthContext);

  return (
    <Grid container item className={pbRoot}>
      <SectionTitle title="Bio" />
      <Typography component="span" gutterBottom className={pbBio}>
        {data.profile.bio}
      </Typography>
      <SectionTitle title="Info" />
      <List>
        <ListItem title="Correo" value={data.email} />
        <ListItem title="Nombre" value={data.profile.screen_name} />
        <ListItem title="Instagram" value={data.profile.ig_profile} />
      </List>
      <UserSubscriptions
        data={data.campaign_subscriptions}
        title="Suscripciones activas"
      />
      <Grid container className={pbSignoutContainer}>
        <Typography
          component="span"
          onClick={() => signout(() => history.push("/login"))}
        >
          Cerrar sesión
        </Typography>
      </Grid>
    </Grid>
  );
};

export default withRouter(ProfileInfo);
